import React from 'react';
export function Footer() {
  return <footer className="border-t border-accent/20 bg-inverse px-4 py-8 text-center" data-id="element-153" data-mp="32wd2cf6gdjt0">
      <p className="text-sm text-inverse-foreground/60" data-id="element-154" data-mp="3gg0yw2enzvx4">
        © 2026 Barre Instructor Ready — All rights reserved.
      </p>
    </footer>;
}